/////////////////////////////////////////////////V5CommentStart
// 2021-03-16 - Big Cleanup
/////////////////////////////////////////////////V5CommentEnd 
import React from 'react'
import {
  Grid,
  Row,
  Col,
  Table,
  Image,
  Tab,
  Tabs,
  Clearfix,
} from 'react-bootstrap'
import { Link, Route } from 'react-router-dom'
import Slider from 'react-slick'
import { getDealerByDid } from '../../utils/rest'

import Sentinel from '../Sentinel'
import VinAuditButton from './VinAuditButton'
import SaveCarButton from './SaveCarButton'
import ContactDealerForm from '../ContactDealerForm'
import Dealers from './Dealers'
import DataView from './DataView'
import Distance from './Distance'

import './Inventory.css'

/* march 11 took this out  haha  what year?
                    <Row>
                    <p> d {item.detailLevel}  {item.detailDisplayFlags.showContactForm ? 'YES' : 'NO'}  </p>
                    </Row>
*/


const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoSpeed: 10000,
  slidesToScroll: 1,
}

class Carousel extends React.PureComponent {
  render() {
    return (
      <Slider className="detail-carousel" {...sliderSettings} slidesToShow={1}>
        {this.props.images.map(image => (
          <Image
            responsive
            key={image}
            width={550}
            height={550}
            alt=""
            src={image}
          />
        ))}
      </Slider>
    )
  }
}

class ItemSummary extends React.Component {
  render() {
    const { item, app } = this.props
    if (item.error)
      return (
        <React.Fragment>
              

          <Row>
            <Col className="header" xs={this.props.featured ? 12 : 10}>
              <h3>VIN {item.vin} (out of stock)</h3>
              {this.props.app.isSavedCar(item.vin) && (
                <em>
                  This item is out of stock. Please remove this item from your
                  wish list.
                </em>
              )}
            </Col>
            {!this.props.featured && (
              <Col xs={2} className="wish-list">
                <SaveCarButton
                  onClick={this.props.app.savedCarsToggle}
                  vin={item.vin}
                  on={this.props.app.isSavedCar(item.vin)}
                />
              </Col>
            )}
          </Row>
        </React.Fragment>
      )
    let dealerRow = null
    //make a change DDFIX 
  if (item.detailDisplayFlags.showDealerAddress)
  {
	dealerRow = 
	(
	      <tr>
	        <th>Dealer:</th>
	        <td>
	          <Link to={`/dealers/${item.dealer.did}`}>{item.dealer.name}</Link>
	        </td>
	      </tr>
	)  	
  }
  
   
    let distance = null
    let phone = null
    const dealer = { ...item.dealer, ...this.props.dealer }
    if (dealer) {
      if (dealer.location.distance) {
        const sas = app.searchAreaSupplemental
        distance = (
          <tr>
            <th>Distance:</th>
            <td>
              <Sentinel silent>
                <Distance here={sas} there={dealer.location} />
              </Sentinel>
            </td>
          </tr>
        )
      }
      phone = dealer.phone ? (
        <tr>
          <th>Telephone:</th>
          <td>
            {dealer.phone.replace(
              /^(\d{3})(\d{3})(\d{4})(.*)/,
              '($1) $2-$3 $4'
            )}
          </td>
        </tr>
      ) : null
    }

    item.price = parseFloat(item.price.toString())

    return (
      <React.Fragment>
        <Row>
          <Col className="header" xs={this.props.featured ? 12 : 10}>
            <h3>
              {item.year} {item.model.make.name} {item.model.name}
            </h3>
          </Col>
          {!this.props.featured && (
            <Col xs={2} className="wish-list">
              <SaveCarButton
                onClick={this.props.app.savedCarsToggle}
                vin={item.vin}
                on={this.props.app.isSavedCar(item.vin)}
              />
            </Col>
          )}
        </Row>
        <Row>
          <Col
            xs={12}
            sm={this.props.featured ? 12 : this.props.detail ? 6 : 3}
          >
             <Row >
        </Row>
            <Row>
              {this.props.detail
                ? item.images && (
                    <Col xs={12}>
                      <Carousel images={item.images} />
                    </Col>
                  )
                : item.thumbnail && (
                    <Col xs={12} className="car-image">
                      <Image
                        responsive
                        src={item.thumbnail}
                        alt={`${item.model.make.name}  ${item.model.name}`}
                      />
                    </Col>
                  )}
            </Row>
            {!this.props.detail && (
              <Row>
                <Col xs={12} className="price">
                  {item.price === 0 ? 'N/A' : `$${item.price.toLocaleString()}`}
                </Col>
              </Row>
            )}
          </Col>
          <Col
            xs={12}
            sm={this.props.featured ? 12 : this.props.detail ? 6 : 9}
            className="summary"
          >
            {this.props.detail && (
              <Row>
                <Col xs={12} className="price">
                  {item.price === 0 ? 'N/A' : `$${item.price.toLocaleString()}`}
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12}>
                <Table responsive condensed className="summary">
                  <tbody>
                    <tr>
                      <th>Mileage:</th>
                      <td>{parseFloat(item.mileage).toLocaleString()}</td>
                    </tr>
                    <tr>
                      <th>Engine:</th>
                      <td>
                        {item.engine} with {item.transmission} trans.
                      </td>
                    </tr>
                    <tr>
                      <th>Body:</th>
                      <td>
                        {item.model.body}
                        {item.model.trim && `/ ${item.model.trim}`}
                      </td>
                    </tr>
                    <tr>
                      <th>Interior:</th>
                      <td>{item.interior}</td>
                    </tr>
                    <tr>
                      <th>Exterior:</th>
                      <td>{item.exterior}</td>
                    </tr>
                    {this.props.detail &&
                      !this.props.featured && (
                        <tr>
                          <th>VIN:</th>
                          <td>
                            <VinAuditButton vin={item.vin} />
                          </td>
                        </tr>
                      )}
                    {this.props.detail && (
                      <tr>
                        <th>Stock Number:</th>
                        <td>{item.stockNumber}</td>
                      </tr>
                    )}
                    {dealerRow}
                    {distance}
                    {phone}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Col>
        </Row>




      </React.Fragment>
    )
  }
}

class Featured extends React.Component {
  render() {
    const { title } = this.props
    const featured = this.props.items.map(
      item => (
        <Grid key={item.vin}>
          <Link
            to={{ pathname: `/inventory/${item.vin}` }}
            disabled={item.error}
          >
            <ItemSummary {...this.props} item={item} />
          </Link>
        </Grid>
      ),
      this
    )

    return this.props.items.length === 0 ? null : (
      <React.Fragment>
        {title && <h3>{title}</h3>}
        <Slider
          className="DataView inventory featured"
          {...sliderSettings}
          slidesToShow={3}
          responsive={[
            {
              breakpoint: 992,
              settings: { ...sliderSettings, slidesToShow: 2 },
            },
            {
              breakpoint: 768,
              settings: { ...sliderSettings, slidesToShow: 1 },
            },
          ]}
        >
          {featured}
        </Slider>
      </React.Fragment>
    )
  }
}

class Listing extends React.Component {
  render() {
    return this.props.items
      .map(
        item => (
          <Col
            xs={12}
            md={6}
            key={item.vin}
            componentClass="article"
            className="inventory data-item"
          >
            <Col xs={12} className="container">
              <Link
                to={item.error ? {} : { pathname: `/inventory/${item.vin}` }}
              >
                <Row>
                  <Col xs={12}>
                    <ItemSummary {...this.props} item={item} />
                  </Col>
                </Row>
              </Link>
            </Col>
          </Col>
        ),
        this
      )
      .reduce(
        (acc, el, i) => [
          ...acc,
          el,
          // Add clearfix after every other (right-most) column
          // This will need to be adjusted if grid design changes
          i % 2 ? <Clearfix key={i} /> : undefined,
        ],
        []
      )
  }
}

class Detail extends React.Component {
  constructor(props) {
    super(props)
    // If navigation is from a dealer listing, then the dealer detail is
    // passed via location.state
    this.state = {
      dealer:
        this.props.did &&
        this.props.location.state &&
        this.props.location.state.dealer,
    }
  }

  componentDidMount() {
    // Async load dealer detail on invetory detail page
    if (
      !this.state.dealer &&
      this.props.detail &&
      this.props.items &&
      this.props.items.length
    ) {
      const did = this.props.items[0].dealer.did
      const myLocationInfo = { ...this.props.app.searchAreaSupplemental }
      getDealerByDid({ did, myLocationInfo })
        .then(dealer => this.setState({ dealer }))
        .catch(err => {
          console.error('getDealerByDid()', this.props.items[0].dealer.did, err)
        })
    }
  }

  render() {
    if (this.props.items.length === 0) return null
    const item = this.props.items[0]
    const n = Math.ceil(item.options.length / 3)
    const list = [
      item.options.slice(0, n),
      item.options.slice(n, n * 2),
      item.options.slice(n * 2),
    ]

    return (
      <Col
        xs={12}
        key={item.vin}
        componentClass="article"
        className="inventory data-item"
      >
        <Col xs={12} className="container">
          <Row>
            <Col xs={12}>
              <ItemSummary
                {...this.props}
                dealer={this.state.dealer}
                item={item}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Tabs
                defaultActiveKey={item.options.length > 0 ? 1 : 2}
                id="inventory-details"
              >
                {item.options.length > 1  && (
                  <Tab eventKey={1} title="Options" className="options">

                    <Row>
                      <Col xs={12} sm={4}>
                  
                        <ul>
                          {' '}
                          {list[0].map((v, k) => <li key={k}> {v } </li>)}{' '}
                        </ul>
                      </Col>
                      <Col xs={12} sm={4}>
                        <ul>
                          {' '}
                          {list[1].map((v, k) => (
                            <li key={list[0].length + k}> {v} </li>
                          ))}{' '}
                        </ul>
                      </Col>
                      <Col xs={12} sm={4}>
                        <ul>
                          {' '}
                          {list[2].map((v, k) => (
                            <li key={list[0].length + list[1].length + k}>
                              {' '}
                              {v}
                            </li>
                          ))}{' '}
                        </ul>
                      </Col>
                    </Row>
                  </Tab>
                )}

                { item.detailDisplayFlags.showDealerAddress &&
                	(
		                <Tab eventKey={2} title="Dealer Information">
		                  <Row>
		                    {this.state.dealer && 
		                    (
		                      <Dealers
		                        detail
		                        {...this.props}
		                        type={'dealers'}
		                        items={[this.state.dealer]}
		                      />
		                    )}
		                  </Row>
		                </Tab>
		             )   
				}
                
                { item.blurb &&(
                  <Tab eventKey={3} title="Dealer Comments">
                    <p>{item.blurb}</p>
                  </Tab>
                )}
                { item.detailDisplayFlags.showContactForm  && (
                  <Tab eventKey={4} title="Contact the Dealer" >

				  <Row>
                      <Col xs={12} md={8} mdOffset={2}>
                        <ContactDealerForm vin={item.vin} />
                      </Col>
                    </Row>
                  </Tab>
                )}
              </Tabs>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Route
                exact
                path="/inventory/:vin"
                render={props => (
                  <DataView.Inventory.Featured
                    {...props}
                    search={{
                      ipp: '5',
                      page: '1',
                      
                    }}
                    title="Similar Cars"
                  />
                )}
              />
            </Col>
          </Row>
        </Col>
      </Col>
    )
  }
}

export default class Inventory extends React.Component {
  render() {
    if (!this.props.items) return null
    if ('featured' in this.props) return <Featured {...this.props} />
    if ('detail' in this.props) return <Detail {...this.props} />
    if ('list' in this.props) return <Listing {...this.props} />
    throw new Error('DataView inventory missing display directive prop')
  }
}



// WEBPACK FOOTER //
// ./src/components/DataView/Inventory.js